import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftToLine } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { _js } from '@ifixit/localize';

export const GridRemoveColumnButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().decreaseColumns().run()}
         isDisabled={!editor.can().decreaseColumns()} // Assuming a can method to check if columns can be decreased
         icon={<FontAwesomeIcon icon={faLeftToLine} />}
         title={_js('Remove column')}
      />
   );
};
